import { useEffect, useState } from 'react'

export const useInitialMode = () => {
  const [mode, setMode] = useState<'phone' | 'email'>('phone')
  const [initialStyle, setInitialStyle] = useState<React.CSSProperties>()

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const regType = params.get('reg_type')

    if (regType === 'email' || regType === 'phone') {
      setMode(regType)
    }

    setInitialStyle({
      flexDirection: regType === 'phone' ? 'row-reverse' : undefined,
    })
  }, [])

  return { mode, setMode, initialStyle }
}